export default {
  'Achievements.LeftAssignments.Completed': ({ clickable }, outlet) => {
    if (clickable) {
      outlet({ stat: 'completed' })
    }
  },
  'Achievements.LeftAssignments.Callbacks': ({ clickable }, outlet) => {
    if (clickable) {
      outlet({ stat: 'callback' })
    }
  },
  'Achievements.RightAssignments.Assigned': ({ clickable }, outlet) => {
    if (clickable) {
      outlet({ stat: 'assigned' })
    }
  },
}